import Carousel from 'Assets/js/lib/carousel'
;(function () {
  const components = {
    featureFlipCardsCarousel: SAXX.Init.Component((node, ctx) => {
      new Carousel(node, {
        cell: '.flip-card',
      })

      node.querySelectorAll('.flip-card .trigger').forEach((a) =>
        a.addEventListener('click', () => {
          a.closest('.flip-card').classList.toggle('active')
        }),
      )
    }),
  }
  SAXX.Init.AddComponents(components)
})()
